import { render, staticRenderFns } from "./PracticeProfile.vue?vue&type=template&id=7329b2b0"
import script from "./PracticeProfile.vue?vue&type=script&lang=js"
export * from "./PracticeProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports